import React from 'react';
import {observer} from "mobx-react-lite";
import { Layout } from '../modules/Layout';
import Main from '../modules/Main';

export const MainPage = observer(() => {
    return (
        <Layout offset={{left: 1}}>
            <Main/>
        </Layout>
    )
});
      